
import i18next from 'i18next'
var dataTranslate = undefined;
var FirstLanguage = Array;
var SecondLanguage = Array;
function dataSetTranslate(data)
{
    //console.log(data)
    dataTranslate = data;
    FirstLanguage = {
        "buttons.Resetpass": data.login_reset_button_text_first,
        "buttons.Save": data.main_buttons_save_first, 
        "buttons.Update": data.main_buttons_update_first, 
        "buttons.Change": data.main_buttons_change_first, 
        "buttons.Blocked": data.main_buttons_blocked_first, 
        "buttons.UnBlocked": data.main_buttons_unblocked_first, 
        
        "Alert.login": data.login_alert_login_first,
        "Alert.exit": data.login_alert_exit_first, 
        "Alert.CookiesNotEqual": data.login_alert_cookiesNotEqual_first,
        "Alert.cancel": data.main_alert_cancel_first,
        "Alert.confirm": data.main_alert_confirm_first,
        "Alert.TabNotAvailable":data.main_alert_tabNotAvailable_first,
    
        "Login.Enter": data.login_button_text_first,
        "Login.Password": data.login_password_text_first,
        "Login.Number Card": data.login_text_first,
        "Login.requiredCard": data.login_alert_requiredCard_first, 
        "Login.Card": data.login_card_first,
        "Login.Phone": data.login_phone_first,
        "Login.Email": data.login_email_first,
    
        "Navigation.NotActivateCard": data.navigation_no_active_card_first,
        "Navigation.Personal account": data.navigation_personal_acc_first,
        "Navigation.Statistics": data.navigation_statistics_first,
        "Navigation.Operations": data.navigation_operations_first,
        "Navigation.Cashback": data.navigation_cashback_first,
        "Navigation.TransferMoney": data.navigation_transferring_funds_first,
        "Navigation.Limits":data.navigation_limits_first,
        "Navigation.Profile":data.navigation_profile_first,
        "Navigation.Security":data.navigation_security_first,
        "Navigation.NightMode":data.navigation_night_thema_first,
        "Navigation.Exit": data.navigation_exit_first,
        "Navigation.About": data.navigation_about_first,
        "Navigation.Menu": data.navigation_menu_first,
    
        "Statistics.Bonus":data.statistics_bonus_text_first,
        "Statistics.Default card":data.statistics_card_text_first,
        "Statistics.Current card category":data.statistics_card_category_first,
        "Statistics.Bonuses in recent months": data.statistics_bonus_recent_first,
        "Statistics.Barcode": data.statistics_barcode_first,
    
        "Statistics.Card": data.operations_card_first,
        "Statistics.Total": data.statistics_total_first,
    
        "Statistics.Date": data.statistics_date_first,
        "Statistics.sum": data.statistics_sum_first,
        "Statistics.Number": data.statistics_number_first,
        "Statistics.of": data.statistics_of_first,
        "Statistics.Code": data.statistics_code_first,
    
        "Statistics.Main":data.statistics_tab1_text_first, 
        "Statistics.Purchase statistics":data.statistics_tab2_text_first, 
        "Statistics.Refill":data.statistics_tab3_text_first,
        "Statistics.BonusByRecall":data.statistics_tab4_text_first,
        "Statistics.PromoCode":data.statistics_tab5_text_first,

        "Statistics.ConfirmSMS": data.statistics_confirm_sms_first,
        "Statistics.categoryError": data.statistics_category_error_first,
        "Statistics.SuccessChangeCategory": data.statistics_success_category_first,
        "Statistics.CanceledCode" : data.statistics_canceled_code_first,
        "Statistics.SendSMS": data.statistics_send_sms_first,
        "Statistics.unknownPhone":data.statistics_unknown_phone_first,
        "Statistics.ComparisonCode":data.statistics_comparison_code_first,
    
        "Statistics.Accommodation counters": data.statistics_accommodation_first,
        "Statistics.Nomenclature":data.statistics_nomenclature_first,
        "Statistics.Previous month": data.statistics_previous_month_first,
        "Statistics.This month":data.statistics_this_month_first,
        "Statistics.All the time":data.statistics_all_the_time_first,
        "Statistics.checks":data.statistics_checks_first,
    
        "Statistics.Discounts":data.statistics_discount_first,
        "Statistics.Last months discount": data.statistics_last_discount_first,
        "Statistics.Discount this month":data.statistics_this_discount_first,
        "Statistics.Discount next month":data.statistics_next_discount_first,
        "Statistics.Purchase Amount":data.statistics_purchase_amount_first,
        "Statistics.Walletbalances":data.statistics_waller_balances_first,
        "Statistics.Seasoned":data.statistics_seasoned_first,
        "Statistics.FundsHistory":data.statistics_funds_history_first,
        "Statistics.FuelHistory":data.statistics_fuel_history_first,
        "Statistics.AllowChangecategory":data.statistics_change_category_first,
    
        "Operations.Beginning":data.operations_beginning_first,
        "Operations.End":data.operations_end_first,
        "Operations.Point of sale":data.operations_location_first,
        "Operations.Type": data.operations_type_first,
        "Operations.Card": data.operations_card_first,
        "Operations.Date": data.operations_date_first,
        "Operations.Type of payment": data.operations_type_of_payment_first,
        "Operations.Product": data.operations_product_first,
        "Operations.Number": data.operations_number_first,
        "Operations.Price without discount":data.operations_price_without_dis_first,
        "Operations.bonuses": data.operations_bonuses_first,
        "Operations.discounts":data.operations_discounts_first,
        "Operations.sum":data.operations_sum_first,
        "Operations.emptyTable":data.operations_empty_table_first, 
    
        "Operations.beginWeek":data.operations_begin_week_first,
        "Operations.beginMonth":data.operations_begin_month_first,
        "Operations.previousMonth":data.operations_previous_month_first,
        "Operations.beginYear":data.operations_begin_year_first,
        "Operations.30days":data.operations_third_days_first,
        "Operations.7days":data.operations_seven_days_first,
        "Operations.Period":data.operations_period_first,
    
        "Cashback.Cashback":data.cashback_name_first,
        "Cashback.Rule":data.cashback_rule_first,
        "Cashback.with":data.cashback_with_first,
        "Cashback.Select":data.cashback_select_first,
        "Cashback.position":data.cashback_position_first,
        "Cashback.Cashback is not available":data.cashback_is_not_available_first,
        "Cashback.selectMax": data.cashback_select_max_first,
        "Cashback.Current rules":data.cashback_current_rules_first,
        "Cashback.Expected rules":data.cashback_expected_rules_first,
        "Cashback.Days left":data.cashback_days_left_first,

        "TransferMoney.Transfer":data.transfer_Transfer_first,
        "TransferMoney.Transaction":data.transfer_Transaction_first,
        "TransferMoney.source":data.transfer_source_first,
        "TransferMoney.receiver":data.transfer_receiver_first,
        "TransferMoney.on account":data.transfer_on_account_first,
        "TransferMoney.accounts":data.transfer_accounts_first,
        "TransferMoney.subAccounts":data.transfer_subAccounts_first,
        "TransferMoney.remainder":data.transfer_remainder_first,
        "TransferMoney.Nomenclature":data.transfer_Nomenclature_first,
        "TransferMoney.card":data.transfer_card_first,
        "TransferMoney.Available":data.transfer_Available_first,
        "TransferMoney.Card wallet selected":data.transfer_Card_wallet_selected_first,
        "TransferMoney.chooseWallets":data.transfer_chooseWallets_first,
        "TransferMoney.chooseAccount":data.transfer_chooseAccount_first,
        "TransferMoney.sum":data.transfer_sum_first,
        "TransferMoney.Transfering":data.transfer_Transfering_first,
        "TransferMoney.transferFuel":data.transfer_transferFuel_first,
        "TransferMoney.transferFunds":data.transfer_transferFunds_first,
        "TransferMoney.The value must be greater than zero":data.transfer_The_value_must_be_greater_than_zero_first,
        "TransferMoney.The source nomenclature must match the destination nomenclature":data.transfer_The_source_nomenclature_must_match_the_destination_nomenclature_first,
        "TransferMoney.Transfer is allowed only between different accounts-wallets":data.transfer_Transfer_is_allowed_only_between_different_accounts_wallets_first,
        "TransferMoney.TransferSuccess":data.transfer_TransferSuccess_first,
    
        "Limits.Card":data.limits_card_first,
        "Limits.Purse":data.limits_purse_first,
        "Limits.Daily":data.limits_daily_first,
        "Limits.Weekly":data.limits_weekly_first,
        "Limits.Monthly":data.limits_monthly_first,
        "Limits.Day limit":data.limits_day_first,
        "Limits.Week limit":data.limits_week_first,
        "Limits.Month limit":data.limits_month_first,
        "Limits.Written off bonuses":data.limits_used_bonuses_first,
    
        "Profile.Legalname":"Юридичне найменування",
        "Profile.CodeEGRPOU":"Код по ЄДРПОУ",
        "Profile.INN":"ІНП",
        "Profile.Certificatenumber":"Номер свідотства",
        "Profile.Gender":"Стать",
        "Profile.Date of birth":"Дата народження",
        "Profile.Address":"Адреса",
        "Profile.Phone":"Телефон",
        "Profile.Email":"E-mail",
        "Profile.Name":"Найменування",
        "Profile.Second name":"Прізвище",
        "Profile.First name":"Ім'я",
        "Profile.Thirt name":"Ім'я по батькові",
        "Profile.Subscription":"Підписка",
        "Profile.CategotyCar":"Категорія авто",
        "Profile.MarkCar":"Марка авто",
        "Profile.Enginevolume":"Об'єм двигуна",
        "Profile.Consumption":"Споживання на 100км,л",
        "Profile.ManufacturerGBO":"Виробник ГБО",
        "Profile.Note":"Примітка",
        "Profile.NumberCar":"Номер авто",
        "Profile.City":"Місто",

        "Profile.Edit":data.clientInfo_edit_error_first,
        "Profile.Invalid Date Format":data.clientInfo_invalid_date_first,
        "Profile.Date should not be after maximal date":data.clientInfo_date_after_max_first,
        "Profile.Date should not be before minimal date":data.clientInfo_date_before_min_first,
        "Profile.Invalid Field":data.clientInfo_invalid_field_first,
        "Profile.NoSearchData":data.clientInfo_no_search_data_first,
    
        "Profile.Required data":data.clientInfo_main_data_first,
        "Profile.Additional data":data.clientInfo_add_data_first,
        "Profile.text_rule":data.clientInfo_profile_text_rule_first,

        "Profile.18 years old":data.clientInfo_year_agree_first,
        "Profile.I agree with the rules": data.clientInfo_rule_agree_first,
        "Profile.rules":data.clientInfo_url_rules_first,
        "Profile.cancel": data.clientInfo_cancel_first,
        "Profile.agree": data.clientInfo_agree_first,
        "Profile.Rule": data.clientInfo_rule_first,
        "Profile.resend code": data.clientInfo_resend_code_first,
        "Profile.activate":data.clientInfo_activate_first,
        "Profile.activate_code":data.clientInfo_activate_code_first,
        "Profile.Code":data.clientInfo_code_first,
    
        "Security.Oldpass":data.security_old_password_first,
        "Security.Confirm new password":data.security_confirm_password_first,
        "Security.New password":data.security_new_password_first,
        "Security.Card":data.security_card_first,
        "Security.Old PIN":data.security_old_pin_first,
        "Security.New PIN":data.security_new_pin_first,
        "Security.lengthError":data.security_length_error_first,
        "Security.to":data.security_to_first,
        "Security.symbols":data.security_symbols_first,
        "Security.enterErrorNumber":data.security_enter_error_number_first,
        "Security.enterErrorChar":data.security_enter_error_char_first,
        "Security.enterErrorNumberAndChar":data.security_enter_error_numchar_first,
        "Security.enterOldPass":data.security_enter_old_pass_first,
        "Security.enterConfirmPass":data.security_enter_confirm_pass_first,
    
        "Security.cardUnBlocked":data.security_card_unblocked_first,
        "Security.cardBlocked":data.security_card_blocked_first,
        "Security.cardIssued":data.security_card_issued_first,
        "Security.notConfirmPass":data.security_notConfirm_pass_first,
    
        "Function not available":data.main_function_not_avaliable_first,
        "No card specified":data.main_not_card_specified_first,
        "Card not found":data.main_card_not_found_first,
        "No counterpart found":data.main_no_counterpart_found_first,
        "Email is not specified in the questionnaire Contact support":data.main_email_not_specified_first,
        "Function not available (code 1) Contact support":data.main_func_not_avaliable_1_first,
        "Function not available (code 2) Contact support":data.main_func_not_avaliable_2_first,
        "Function not available (code 3) Contact support":data.main_func_not_avaliable_3_first,
        "Function not available (code 4) Contact support":data.main_func_not_avaliable_4_first,
        "Invalid data":data.main_invalid_data_first,
        "A password confirmation email has been sent to your mail":data.main_password_confirmation_first,
        "Error sending message":data.main_error_sending_message_first,
        "Invalid request":data.main_invalid_request_first,
        "Error performing operation":data.main_error_performing_req_first,
        "Not an existing request":data.main_not_an_existinf_req_first,
        "Request timed out":data.main_request_time_out_first,
        "The operation failed":data.main_the_operation_failed_first,
        "Password changed_Mail":data.main_new_password_sent_email_first,
        "Password successfully changed_Number":data.main_new_password_sent_phone_first,
        "Error resetting password":data.main_error_reset_password_first,
        "The operation is performed too often Please try again later":data.main_op_performed_too_often_first,
        "Wallet not found":data.main_wallet_not_found_first,
        "Questionnaire is not available":data.main_profile_not_avaliable_first,
        "Invalid data format":data.main_invalid_data_format_first,
        "Error processing request":data.main_error_processing_req_first,
        "The operation cannot be performed":data.main_op_cannot_be_performed_first,
        "User not found":data.main_user_not_found_first,
        "No password specified":data.main_no_password_specified_first,
        "Error":data.main_error_first,
        "Invalid password":data.main_invalid_password_first,
        "Invalid data reset":data.clientInfo_login_fail_first,
        "Phone number not specified in the questionnaire Contact support":data.main_phone_not_found_first,
        
        "Не удалось отправить код подтверждения":data.main_confirm_not_send_first,
        "Налаштування Cashback збережені":data.cashback_save_first,
        "Вы ничего не выбрали :(": data.cashback_no_select_first,
        "Лимиты изменены":data.limits_changed_first,
        "Лимит не может быть отрицательным":data.limits_negative_first,
        "Не верный кошелек":data.limits_wrong_wallet_first,
        "Кошелек не найден":data.limits_wallet_not_found_first,
        "Не указан кошелек":data.limits_wallet_not_select_first,
        "Не найдена неактивная карта":data.clientInfo_no_inactive_card_first,
        "Персональные данные изменены. Карта активирована":data.clientInfo_card_activate_first,
        "Карта активирована":data.clientInfo_card_activate_first,
        "Персональные данные изменены":data.clientInfo_data_changed_first,
        "Не указана карта":data.security_missing_card_first,
        "Не указан новый PIN-код":data.security_missing_pin_first,
        "Карта не найдена":data.security_card_not_found_first,
        "Не указан старый PIN-код":data.security_not_found_old_pin_first,
        "Не верный старый PIN-код":data.security_false_old_pin_first,
        "Не верный формат PIN-кода, должны быть только цифры в количестве от 4 до 8":data.security_wrong_pin_format_first,
        "PIN-код изменен":data.security_pin_changed_first,
        "Не заданий пароль":data.security_password_not_enter_first,
        "Невiрний формат паролю":data.security_wrong_pass_format_first,
        "Ошибка обработки пароля":data.security_password_error_first,
        "Пароль змiнений":data.security_password_change_first,
        "Персональные данные изменены. На указанный номер телефона отправлен код активации": data.clientInfo_change_and_active_first,
        "Код активации повторно отправлен на указанный в профиле номер телефона":data.clientInfo_resending_code_first,
        "Превышено количество попыток отправки кода активации": data.clientInfo_too_much_try_first,
        "Код активации не указан": data.clientInfo_code_is_absent_first,
        "Не верный код активации":data.clientInfo_activation_fail_first,
        "Данный номер телефона уже используется другим клиентом":data.clientInfo_phone_used_first,
        "Карта будет разблокирована":data.security_unblock_card_first,
        "Карта будет заблокирована":data.security_block_card_first,
        "Персональные данные изменены. Не удалось отправить код активации. Не указан номер телефона":"Персональні дані змінені. Не вдалося відправити код активації. Не вказаний номер телефону",
        "Не удалось отправить код активации":data.main_confirm_not_send_first,
        "Не верный текущий пароль":data.security_fail_current_pass_first,
    }
    SecondLanguage = {
        "buttons.Resetpass": data.login_reset_button_text_second,
        "buttons.Save": data.main_buttons_save_second,
        "buttons.Update": data.main_buttons_update_second,
        "buttons.Change": data.main_buttons_change_second, 
        "buttons.Blocked": data.main_buttons_blocked_second,
        "buttons.UnBlocked": data.main_buttons_unblocked_second, 
    
        
        "Alert.login": data.login_alert_login_second,
        "Alert.exit": data.login_alert_exit_second,
        "Alert.CookiesNotEqual": data.login_alert_cookiesNotEqual_second,
        "Alert.cancel": data.main_alert_cancel_second,
        "Alert.confirm": data.main_alert_confirm_second,
        "Alert.TabNotAvailable":data.main_alert_tabNotAvailable_second,
    
        "Login.Enter": data.login_button_text_second,
        "Login.Password": data.login_password_text_second,
        "Login.Number Card": data.login_text_second,
        "Login.requiredCard": data.login_alert_requiredCard_second,
        "Login.Card": data.login_card_second,
        "Login.Phone": data.login_phone_second,
        "Login.Email": data.login_email_second,
    
        "Navigation.NotActivateCard": data.navigation_no_active_card_second,
        "Navigation.Personal account": data.navigation_personal_acc_second,
        "Navigation.Statistics": data.navigation_statistics_second,
        "Navigation.Operations": data.navigation_operations_second,
        "Navigation.Cashback": data.navigation_cashback_second,
        "Navigation.TransferMoney": data.navigation_transferring_funds_second,
        "Navigation.Limits":data.navigation_limits_second,
        "Navigation.Profile":data.navigation_profile_second,
        "Navigation.Security":data.navigation_security_second,
        "Navigation.NightMode":data.navigation_night_thema_second,
        "Navigation.Exit": data.navigation_exit_second,
        "Navigation.About": data.navigation_about_second,
        "Navigation.Menu": data.navigation_menu_second,
    
        "Statistics.Bonus":data.statistics_bonus_text_second,
        "Statistics.Default card":data.statistics_card_text_second,
        "Statistics.Current card category":data.statistics_card_category_second,
        "Statistics.Bonuses in recent months": data.statistics_bonus_recent_second,
        "Statistics.Barcode": data.statistics_barcode_second,
    
        "Statistics.Card": data.operations_card_second,
        "Statistics.Total": data.statistics_total_second,
    
        "Statistics.Date": data.statistics_date_second,
        "Statistics.sum": data.statistics_sum_second,
        "Statistics.Number": data.statistics_number_second,
        "Statistics.of": data.statistics_of_second,
        "Statistics.Code": data.statistics_code_second,
    
        "Statistics.Main":data.statistics_tab1_text_second, 
        "Statistics.Purchase statistics":data.statistics_tab2_text_second, 
        "Statistics.Refill":data.statistics_tab3_text_second,
        "Statistics.BonusByRecall":data.statistics_tab4_text_second,
        "Statistics.PromoCode":data.statistics_tab5_text_second,

        "Statistics.ConfirmSMS": data.statistics_confirm_sms_second,
        "Statistics.categoryError": data.statistics_category_error_second,
        "Statistics.SuccessChangeCategory": data.statistics_success_category_second,
        "Statistics.CanceledCode" : data.statistics_canceled_code_second,
        "Statistics.SendSMS": data.statistics_send_sms_second,
        "Statistics.unknownPhone":data.statistics_unknown_phone_second,
        "Statistics.ComparisonCode":data.statistics_comparison_code_second,
    
        "Statistics.Accommodation counters": data.statistics_accommodation_second,
        "Statistics.Nomenclature":data.statistics_nomenclature_second,
        "Statistics.Previous month": data.statistics_previous_month_second,
        "Statistics.This month":data.statistics_this_month_second,
        "Statistics.All the time":data.statistics_all_the_time_second,
        "Statistics.checks":data.statistics_checks_second,
    
        "Statistics.Discounts":data.statistics_discount_second,
        "Statistics.Last months discount": data.statistics_last_discount_second,
        "Statistics.Discount this month":data.statistics_this_discount_second,
        "Statistics.Discount next month":data.statistics_next_discount_second,
        "Statistics.Purchase Amount":data.statistics_purchase_amount_second,
        "Statistics.Walletbalances":data.statistics_waller_balances_second,
        "Statistics.Seasoned":data.statistics_seasoned_second,
        "Statistics.FundsHistory":data.statistics_funds_history_second,
        "Statistics.FuelHistory":data.statistics_fuel_history_second,
        "Statistics.AllowChangecategory":data.statistics_change_category_second,
    
        "Operations.Beginning":data.operations_beginning_second,
        "Operations.End":data.operations_end_second,
        "Operations.Point of sale":data.operations_location_second,
        "Operations.Type": data.operations_type_second,
        "Operations.Card": data.operations_card_second,
        "Operations.Date": data.operations_date_second,
        "Operations.Type of payment": data.operations_type_of_payment_second,
        "Operations.Product": data.operations_product_second,
        "Operations.Number": data.operations_number_second,
        "Operations.Price without discount":data.operations_price_without_dis_second,
        "Operations.bonuses": data.operations_bonuses_second,
        "Operations.discounts":data.operations_discounts_second,
        "Operations.sum":data.operations_sum_second,
        "Operations.emptyTable":data.operations_empty_table_second, 
    
        "Operations.beginWeek":data.operations_begin_week_second,
        "Operations.beginMonth":data.operations_begin_month_second,
        "Operations.previousMonth":data.operations_previous_month_second,
        "Operations.beginYear":data.operations_begin_year_second,
        "Operations.30days":data.operations_third_days_second,
        "Operations.7days":data.operations_seven_days_second,
        "Operations.Period":data.operations_period_second,
    
        "Cashback.Cashback":data.cashback_name_second,
        "Cashback.Rule":data.cashback_rule_second,
        "Cashback.with":data.cashback_with_second,
        "Cashback.Select":data.cashback_select_second,
        "Cashback.position":data.cashback_position_second,
        "Cashback.Cashback is not available":data.cashback_is_not_available_second,
        "Cashback.selectMax": data.cashback_select_max_second,
        "Cashback.Current rules":data.cashback_current_rules_second,
        "Cashback.Expected rules":data.cashback_expected_rules_second,
        "Cashback.Days left":data.cashback_days_left_second,

        "TransferMoney.Transfer":data.transfer_Transfer_second,
        "TransferMoney.Transaction":data.transfer_Transaction_second,
        "TransferMoney.source":data.transfer_source_second,
        "TransferMoney.receiver":data.transfer_receiver_second,
        "TransferMoney.on account":data.transfer_on_account_second,
        "TransferMoney.accounts":data.transfer_accounts_second,
        "TransferMoney.subAccounts":data.transfer_subAccounts_second,
        "TransferMoney.remainder":data.transfer_remainder_second,
        "TransferMoney.Nomenclature":data.transfer_Nomenclature_second,
        "TransferMoney.card":data.transfer_card_second,
        "TransferMoney.Available":data.transfer_Available_second,
        "TransferMoney.Card wallet selected":data.transfer_Card_wallet_selected_second,
        "TransferMoney.chooseWallets":data.transfer_chooseWallets_second,
        "TransferMoney.chooseAccount":data.transfer_chooseAccount_second,
        "TransferMoney.sum":data.transfer_sum_second,
        "TransferMoney.Transfering":data.transfer_Transfering_second,
        "TransferMoney.transferFuel":data.transfer_transferFuel_second,
        "TransferMoney.transferFunds":data.transfer_transferFunds_second,
        "TransferMoney.The value must be greater than zero":data.transfer_The_value_must_be_greater_than_zero_second,
        "TransferMoney.The source nomenclature must match the destination nomenclature":data.transfer_The_source_nomenclature_must_match_the_destination_nomenclature_second,
        "TransferMoney.Transfer is allowed only between different accounts-wallets":data.transfer_Transfer_is_allowed_only_between_different_accounts_wallets_second,
        "TransferMoney.TransferSuccess":data.transfer_TransferSuccess_second,
    
        "Limits.Card":data.limits_card_second,
        "Limits.Purse":data.limits_purse_second,
        "Limits.Daily":data.limits_daily_second,
        "Limits.Weekly":data.limits_weekly_second,
        "Limits.Monthly":data.limits_monthly_second,
        "Limits.Day limit":data.limits_day_second,
        "Limits.Week limit":data.limits_week_second,
        "Limits.Month limit":data.limits_month_second,
        "Limits.Written off bonuses":data.limits_used_bonuses_second,
    
        "Profile.Legalname":"Юридическое наименование",
        "Profile.CodeEGRPOU":"Код по ЕГРПОУ",
        "Profile.INN":"ИНН",
        "Profile.Certificatenumber":"Номер свидетельства",
        "Profile.Gender":"Пол",
        "Profile.Date of birth":"Дата рождения",
        "Profile.Address":"Адрес",
        "Profile.Phone":"Телефон",
        "Profile.Email":"E-mail",
        "Profile.Name":"Наименование",
        "Profile.Second name":"Фамилия",
        "Profile.First name":"Имя",
        "Profile.Thirt name":"Отчество",
        "Profile.Subscription":"Подписка",
        "Profile.CategotyCar":"Категория авто",
        "Profile.MarkCar":"Марка авто",
        "Profile.Enginevolume":"Объем двигателя",
        "Profile.Consumption":"Потребление на 100км,л",
        "Profile.ManufacturerGBO":"Производитель ГБО",
        "Profile.Note":"Примечание",
        "Profile.NumberCar":"Номер авто",
        "Profile.City":"Город",

        "Profile.Edit":data.clientInfo_edit_error_second,
        "Profile.Invalid Date Format":data.clientInfo_invalid_date_second,
        "Profile.Date should not be after maximal date":data.clientInfo_date_after_max_second,
        "Profile.Date should not be before minimal date":data.clientInfo_date_before_min_second,
        "Profile.Invalid Field":data.clientInfo_invalid_field_second,
        "Profile.NoSearchData":data.clientInfo_no_search_data_second,
    
        "Profile.Required data":data.clientInfo_main_data_second,
        "Profile.Additional data":data.clientInfo_add_data_second,
        "Profile.text_rule":data.clientInfo_profile_text_rule_second,
        
        "Profile.18 years old":data.clientInfo_year_agree_second, 
        "Profile.I agree with the rules":data.clientInfo_rule_agree_second,
        "Profile.rules":data.clientInfo_url_rules_second, 
        "Profile.cancel": data.clientInfo_cancel_second,
        "Profile.agree": data.clientInfo_agree_second,
        "Profile.Rule": data.clientInfo_rule_second, 
        "Profile.resend code":data.clientInfo_resend_code_second,
        "Profile.activate":data.clientInfo_activate_second,
        "Profile.activate_code":data.clientInfo_activate_code_second,
        "Profile.Code":data.clientInfo_code_second,
    
        "Security.Oldpass":data.security_old_password_second,
        "Security.Confirm new password":data.security_confirm_password_second,
        "Security.New password":data.security_new_password_second,
        "Security.Card":data.security_card_second,
        "Security.Old PIN":data.security_old_pin_second,
        "Security.New PIN":data.security_new_pin_second,
        "Security.lengthError":data.security_length_error_second,
        "Security.to":data.security_to_second,
        "Security.symbols":data.security_symbols_second,
        "Security.enterErrorNumber":data.security_enter_error_number_second,
        "Security.enterErrorChar":data.security_enter_error_char_second,
        "Security.enterErrorNumberAndChar":data.security_enter_error_numchar_second,
        "Security.enterOldPass":data.security_enter_old_pass_second,
        "Security.enterConfirmPass":data.security_enter_confirm_pass_second,
    
        "Security.cardUnBlocked":data.security_card_unblocked_second,
        "Security.cardBlocked":data.security_card_blocked_second,
        "Security.cardIssued":data.security_card_issued_second,
        "Security.notConfirmPass":data.security_notConfirm_pass_second,
    
        "Function not available":data.main_function_not_avaliable_second,
        "No card specified":data.main_not_card_specified_second,
        "Card not found":data.main_card_not_found_second,
        "No counterpart found":data.main_no_counterpart_found_second,
        "Email is not specified in the questionnaire Contact support":data.main_email_not_specified_second,
        "Function not available (code 1) Contact support":data.main_func_not_avaliable_1_second,
        "Function not available (code 2) Contact support":data.main_func_not_avaliable_2_second,
        "Function not available (code 3) Contact support":data.main_func_not_avaliable_3_second,
        "Function not available (code 4) Contact support":data.main_func_not_avaliable_4_second,
        "Invalid data":data.main_invalid_data_second,
        "A password confirmation email has been sent to your mail":data.main_password_confirmation_second,
        "Error sending message":data.main_error_sending_message_second,
        "Invalid request":data.main_invalid_request_second,
        "Error performing operation":data.main_error_performing_req_second,
        "Not an existing request":data.main_not_an_existinf_req_second,
        "Request timed out":data.main_request_time_out_second,
        "The operation failed":data.main_the_operation_failed_second,
        "Password changed_Mail":data.main_new_password_sent_email_second,
        "Password successfully changed_Number":data.main_new_password_sent_phone_second,
        "Error resetting password":data.main_error_reset_password_second,
        "The operation is performed too often Please try again later":data.main_op_performed_too_often_second,
        "Wallet not found":data.main_wallet_not_found_second,
        "Questionnaire is not available":data.main_profile_not_avaliable_second,
        "Invalid data format":data.main_invalid_data_format_second,
        "Error processing request":data.main_error_processing_req_second,
        "The operation cannot be performed":data.main_op_cannot_be_performed_second,
        "User not found":data.main_user_not_found_second,
        "No password specified":data.main_no_password_specified_second,
        "Error":data.main_error_second,
        "Invalid password":data.main_invalid_password_second,
        "Invalid data reset":data.clientInfo_login_fail_second,
        "Phone number not specified in the questionnaire Contact support":data.main_phone_not_found_second,
        
        "Не удалось отправить код подтверждения":data.main_confirm_not_send_second,
        "Налаштування Cashback збережені":data.cashback_save_second,
        "Вы ничего не выбрали :(":data.cashback_no_select_second,
        "Лимиты изменены": data.limits_changed_second,
        "Лимит не может быть отрицательным":data.limits_negative_second,
        "Не верный кошелек":data.limits_wrong_wallet_second,
        "Кошелек не найден":data.limits_wallet_not_found_second,
        "Не указан кошелек":data.limits_wallet_not_select_second,
        "Не найдена неактивная карта":data.clientInfo_no_inactive_card_second,
        "Персональные данные изменены. Карта активирована":data.clientInfo_card_activate_second,
        "Карта активирована":data.clientInfo_card_activate_second,
        "Персональные данные изменены":data.clientInfo_data_changed_second,
        "Не указана карта":data.security_missing_card_second,
        "Не указан новый PIN-код":data.security_missing_pin_second,
        "Карта не найдена":data.security_card_not_found_second,
        "Не указан старый PIN-код":data.security_not_found_old_pin_second,
        "Не верный старый PIN-код":data.security_false_old_pin_second,
        "Не верный формат PIN-кода, должны быть только цифры в количестве от 4 до 8":data.security_wrong_pin_format_second,
        "PIN-код изменен":data.security_pin_changed_second,
        "Не заданий пароль":data.security_password_not_enter_second,
        "Невiрний формат паролю":data.security_wrong_pass_format_second,
        "Ошибка обработки пароля":data.security_password_error_second,
        "Пароль змiнений":data.security_password_change_second,
        "Персональные данные изменены. На указанный номер телефона отправлен код активации": data.clientInfo_change_and_active_second,
        "Код активации повторно отправлен на указанный в профиле номер телефона":data.clientInfo_resending_code_second,
        "Превышено количество попыток отправки кода активации": data.clientInfo_too_much_try_second,
        "Код активации не указан": data.clientInfo_code_is_absent_second,
        "Не верный код активации":data.clientInfo_activation_fail_second,
        "Данный номер телефона уже используется другим клиентом":data.clientInfo_phone_used_second,
        "Карта будет разблокирована":data.security_unblock_card_second,
        "Карта будет заблокирована":data.security_block_card_second,
        "Персональные данные изменены. Не удалось отправить код активации. Не указан номер телефона":"Персональные данные изменены. Не удалось отправить код активации. Не указан номер телефона",
        "Не удалось отправить код активации":data.main_confirm_not_send_second,
        "Не верный текущий пароль":data.security_fail_current_pass_second,
    }
}
function GetTranslate(word)
{
    if(dataTranslate == undefined)
    {
        return i18next.t(word);
    }else{
        switch(i18next.options.lng)
        {
            case "uk": if(FirstLanguage[word] != undefined) {return FirstLanguage[word]} else {return word} ;
            case "ru": if(SecondLanguage[word] != undefined) {return SecondLanguage[word]} else {return word};
            default: return null;
        }
         
    }
}
function GT(word)
{
    return i18next.t(word);
}
function ChangeLanguage()
{
    var language;
    switch(i18next.options.lng)
    {
        case "uk": language = "ru"; break;
        case "ru": language = "uk"; break;
        default: return null;
    }
    localStorage.setItem('language', language);
    i18next.init({
        lng: language,
        resources: require(`../${language}.json`)
    });
    return;
}
function language(value)
{
    switch(value)
    {
        case 0: return "uk";
        case 1: return "ru";
        case 2: return "en-au";
        case 3: return "pl";
        case 4: return "fr";
        case 5: return "de";
        case 6: return "es";
        case 7: return "zh-cn";
            default: return "uk";
    }
}
function chooseLangPickers(first,second)
{
    var langDefault = 
    {
        first: language(first),
        second: language(second)
    }
    switch(i18next.options.lng)
    {
        case "uk": return langDefault.first
        case "ru": return langDefault.second
        default: return langDefault.first;
    }
}
export const localization = {
    GetTranslate,
    GT,
    ChangeLanguage,
    dataSetTranslate,
    chooseLangPickers
};

////////////////////////////////////////////////////////////////////////////////
